import { Link, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuthLayout } from "@/components/auth/AuthLayout";
import { OAuthButtons } from "@/components/auth/OAuthButtons";
import { useAuthStore } from "@/stores/authStore";
import logoLight from "@/assets/logo-light.svg";
import logoDark from "@/assets/logo-dark.svg";

export default function LoginPage() {
  const { t } = useTranslation("auth");
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <AuthLayout>
      {/* Logo row */}
      <div className="flex items-center gap-2.5 mb-8">
        <img
          src={logoLight}
          alt="WiServices"
          className="h-[26px] block dark:hidden"
        />
        <img
          src={logoDark}
          alt="WiServices"
          className="h-[26px] hidden dark:block"
        />
        <span className="ml-auto inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border border-hairline bg-panel text-muted font-mono">
          Console
        </span>
      </div>

      {/* Heading */}
      <h2 className="text-2xl font-medium tracking-tight mb-2 text-ink">
        {t("login.welcomeBack")}
      </h2>
      <p className="text-sm text-muted mb-7">{t("login.subtitle")}</p>

      {/* SSO Button */}
      <OAuthButtons />

      {/* Help text */}
      <p className="mt-6 text-center text-xs text-muted">
        {t("login.noAccount")}{" "}
        <Link to="/register" className="text-brand hover:underline">
          {t("login.signUp")}
        </Link>
      </p>
    </AuthLayout>
  );
}
